<template lang="jade" src="./target.jade"></template>

<script>
  export default {
    data () {
      return {
        animated_headline: "https://s3-us-west-1.amazonaws.com/db13/1440/hdr.svg",
        title: 'I Own what you watch',
        copy: 'I spend millions to entertain and delight you. Years hiring the penultimate artists to craft a heady thing of beauty to entrance you. To push you OFF the ledge of your chair. I am here to keep you relevant. Vibrancy, depth, vision… progress spurs relevance. Do not lose all that we have built together. Up-convert on the fly! When I adapt, you adapt. HDR. Holy Damnable Ramifications? High Dynamic Range! Together, we’ll go far. Because entertainment is only as good as you…',
        lastword: 'IMAGINE',
        video: 'https://s3-us-west-1.amazonaws.com/db13/1440/content-owners.mp4',
        back_link: '/content-creators',
        forward_link: '/content-distributors',
        back_img: 'imgs/icons/back-arrow.svg',
        forward_img: 'imgs/icons/forward-arrow.svg',
        back: 'imgs/icons/back-arrow.svg',
        vTransparency: {
          opacity: '0.4'
        }
      }
    }
  }
</script>

<style lang="sass?indentedSyntax" scoped>

  @import "../../_sass/utilities/_utilities.sass"

  h1,
  span.beleive
    color: $med-purple!important

</style>


/** WEBPACK FOOTER **
 ** content-owners.vue?0b42aa92
 **/